<template>
    <!--    <TitlePage :volume-number="volumeNumber" :yearFrom="yearFrom" :yearTo="yearTo"/>-->
    <!--    <SecondPage :year="year"/>-->
    <!--    <ForewordPage :volume-number="volumeNumber" />-->
    <TableOfContents/>
    <AbbreviationsList :abbreviationsList="abbreviationsList"
                       :abbreviationsUsedInVolume="abbreviationsUsedInVolume"/>
    <ImportedHorsesPage :importedHorses="importedHorses" :yearFrom="yearFrom" :yearTo="yearTo"/>
    <BroodmaresPage :broodmares="broodmares" :yearFrom="yearFrom" :yearTo="yearTo"/>
    <StallionsPage :stallions="stallions" :yearFrom="yearFrom" :yearTo="yearTo"/>
    <ExportedHorsesPage :exportedHorses="exportedHorses" :yearFrom="yearFrom" :yearTo="yearTo"/>
    <DeadHorsesPage :deadHorses="deadHorses" :yearFrom="yearFrom" :yearTo="yearTo"/>
    <BreedersPage :breeders="breeders"/>
    <!--    <CorrectionsPage/>-->
    <IndexPage/>
</template>

<script>
import {Previewer} from "pagedjs";
import {getStudbookData} from "@/swagger/vue-api-client";
import TableOfContents from "@/views/readonly/studbook/part/TableOfContents.vue";
import AbbreviationsList from "@/views/readonly/studbook/part/AbbreviationsList.vue";
import IndexPage from "@/views/readonly/studbook/part/IndexPage.vue";
import ImportedHorsesPage from "@/views/readonly/studbook/part/ImportedHorsesPage.vue";
import DeadHorsesPage from "@/views/readonly/studbook/part/DeadHorsesPage.vue";
import BroodmaresPage from "@/views/readonly/studbook/part/BroodmaresPage.vue";
import StallionsPage from "@/views/readonly/studbook/part/StallionsPage.vue";
import ExportedHorsesPage from "@/views/readonly/studbook/part/ExportedHorsesPage.vue";
import BreedersPage from "@/views/readonly/studbook/part/BreedersPage.vue";

export default {
    name: "StudbookPrintView",
    components: {
        BreedersPage,
        ExportedHorsesPage,
        StallionsPage,
        BroodmaresPage,
        DeadHorsesPage,
        ImportedHorsesPage,
        IndexPage,
        AbbreviationsList,
        TableOfContents,
    },
    data() {
        return {
            importedHorses: [],
            deadHorses: [],
            broodmares: [],
            stallions: [],
            exportedHorses: [],
            breeders: [],
            year: new Date().getFullYear(),
            volumeNumber: this.$route.params.volume,
            yearFrom: this.$route.params.from,
            yearTo: this.$route.params.to,
            horseBreed: this.$route.params.breed.toUpperCase(),
            abbreviationsList: [],
            abbreviationsUsedInVolume: [],
            bodyClass: "studbook",
        };
    },
    mounted() {
        const app = document.getElementById("app");
        const noscript = document.getElementsByTagName("noscript")[0];
        if (app) app.classList.add(this.bodyClass);
        if (noscript) noscript.classList.add(this.bodyClass);
        this.getData();
    },
    methods: {
        getData() {
            // console.log("timing:dataFetchStart");
            getStudbookData({yearFrom: this.yearFrom, yearTo: this.yearTo, breed: this.horseBreed})
                .then((response) => {
                    // console.log("timing:dataFetchDone");
                    this.importedHorses = response.data.importedHorses;
                    this.abbreviationsList = Object.entries(response.data.shortcuts.countryShortcuts).map(([name, alpha2]) => ({
                        name,
                        alpha2,
                        alpha3: response.data.shortcuts.studbookShortcuts[alpha2],
                    }));
                    this.abbreviationsUsedInVolume = Object.entries(response.data.shortcuts.shortcuts).map(([abbreviations, explanation]) => ({
                        abbreviations,
                        explanation,
                    }));
                    this.exportedHorses = response.data.exportedHorses;
                    this.deadHorses = response.data.deadHorses;
                    this.broodmares = response.data.broodmares;
                    this.stallions = response.data.stallions;
                    this.breeders = response.data.breeders;

                    // console.log("timing:pagedPreviewStart");
                    const paged = new Previewer();
                    paged.preview();
                })
                .catch((error) => {
                    console.error("Error while downloading horses:", error);
                });
        },
    },

};
</script>

<style lang="scss">
@import "print-styles.scss";
</style>
